module.exports = __webpack_public_path__ + "static/img/home_bg.047eb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_bg.png
// module id = NDl3
// module chunks = 1